import { LEGACY_GLOBAL_CACHE_INSTANCE } from "@/modules/cache/globalCache";
import { CacheKey } from "@/modules/cache/constants";

type ImportSessionMarker = {
  sessionId: string;
  createdAtMs: number;
};

export async function readImportSessionsInProgress(): Promise<ImportSessionMarker[]> {
  try {
    const markers = await LEGACY_GLOBAL_CACHE_INSTANCE.get(CacheKey.ImportSessionsInProgress);
    if (!markers) return [];
    return markers;
  } catch {
    return [];
  }
}

async function writeMarkers(markers: ImportSessionMarker[]): Promise<void> {
  try {
    await LEGACY_GLOBAL_CACHE_INSTANCE.set(CacheKey.ImportSessionsInProgress, markers);
  } catch {
    // noop
  }
}

export async function markImportSessionInProgress(sessionId: string): Promise<void> {
  const markers = await readImportSessionsInProgress();
  if (!markers.some(m => m.sessionId === sessionId)) {
    markers.push({ sessionId, createdAtMs: Date.now() });
    await writeMarkers(markers);
  }
}

export async function clearImportSessionInProgress(sessionId: string): Promise<void> {
  const markers = (await readImportSessionsInProgress()).filter(m => m.sessionId !== sessionId);
  await writeMarkers(markers);
}
